import React, { useState } from 'react';

const CancelModal = ({ order, onClose, onConfirm, loading }) => {
  const [reason, setReason] = useState('');
  const [restoreInventory, setRestoreInventory] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      alert('Please provide a cancellation reason');
      return;
    }
    
    onConfirm({
      reason: reason.trim(),
      restoreInventory
    });
  };

  const totalItems = order?.items?.reduce((sum, item) => sum + item.quantity, 0) || 0;
  const totalAmount = order?.total || 0;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Cancel Order #{order?.orderNumber}
          </h2>
          
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-yellow-800">
                  Cancellation Warning
                </h3>
                <div className="mt-2 text-sm text-yellow-700">
                  <p>This action will:</p>
                  <ul className="list-disc list-inside mt-1 space-y-1">
                    <li>Mark the order as cancelled</li>
                    {restoreInventory && <li>Return all products to inventory</li>}
                    <li>Create an audit trail</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="reason" className="block text-sm font-medium text-gray-700 mb-2">
                Cancellation Reason *
              </label>
              <textarea
                id="reason"
                rows="4"
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                placeholder="Please provide a reason for cancellation (e.g., Customer changed mind, Wrong items ordered, etc.)"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                required
              />
            </div>

            <div className="mb-6">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  checked={restoreInventory}
                  onChange={(e) => setRestoreInventory(e.target.checked)}
                />
                <span className="ml-2 text-sm text-gray-700">
                  Restore all products to inventory ({totalItems} items)
                </span>
              </label>
              <p className="text-xs text-gray-500 mt-1 ml-6">
                Uncheck this only if you want to cancel the order without returning products to stock
              </p>
            </div>

            {order?.payment?.method === 'charge' && (
              <div className="mb-4 p-3 bg-blue-50 border border-blue-200 rounded">
                <p className="text-sm text-blue-800">
                  <strong>Note:</strong> This is a charge order. Cancellation will not automatically 
                  reverse any accounting entries. Please handle accounting separately if needed.
                </p>
              </div>
            )}

            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:opacity-50"
                disabled={loading}
              >
                {loading ? 'Cancelling...' : 'Confirm Cancellation'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CancelModal;